import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle"]

  initialize() {
    this.isVisible = false;
  }

  toggle() {
    if (this.isVisible) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    this.contentTarget.classList.remove("hidden");
    this.toggleTarget.innerText = "Hide details";
    this.isVisible = true;
  }

  hide() {
    this.contentTarget.classList.add("hidden");
    this.toggleTarget.innerText = "Show details";
    this.isVisible = false;
  }
} 